import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

// --- LOGIC UPDATE: 'onScan' prop add kiya ---
export default function ScannerModal({ onClose }) {

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-8 relative max-w-sm w-full text-center">
                <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"><XMarkIcon className="h-6 w-6" /></button>

                {/* --- LOGIC UPDATE: Icon ko clickable banaya --- */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-32 w-32 text-gray-300 mx-auto mb-6 cursor-pointer hover:text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h14.25c.621 0 1.125.504 1.125 1.125v14.25c0 .621-.504 1.125-1.125 1.125H4.875A1.125 1.125 0 013.75 19.125V4.875zM9 9.75h6.375M9 12h6.375m-6.375 2.25h6.375M3 3h7v7H3V3zM14 3h7v7h-7V3zM3 14h7v7H3v-7zM14 14h7v7h-7v-7z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M1.5 6.75v-1.5c0-.966.784-1.75 1.75-1.75h1.5" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M1.5 17.25v1.5c0 .966.784 1.75 1.75 1.75h1.5" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M22.5 6.75v-1.5c0-.966-.784-1.75-1.75-1.75h-1.5" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M22.5 17.25v1.5c0 .966-.784 1.75-1.75 1.75h-1.5" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 7.5v9 M9 7.5v9 M10.5 7.5v9 M12 7.5v9 M13.5 7.5v9 M15 7.5v9 M16.5 7.5v9" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 12h18" />
                </svg>
                <p className="text-lg text-gray-500">Please Scan the Book to add to the cart</p>
            </div>
        </div>
    );
}

